export const IssueSupportTemplateRoutes = {
  LIST: "/settings/issue-support-templates",
  CREATE: "/settings/issue-support-templates/new",
  DETAIL: "/settings/issue-support-templates/:id",
  EDIT: "/settings/issue-support-templates/:id/edit",
} as const;
